import { Button } from "@/components/ui/button";
import { FileText, Flag, Shield } from "@phosphor-icons/react";

export default function BrandRowActions({
  brand, hasDrift, onContract, onEdit, onAudit, onRefPolicy, onDelete,
}) {
  const hasRefOverride = brand?.ref_policy?.status === "active";
  return (
    <div className="flex items-center justify-end gap-1 flex-nowrap">
      <Button
        size="sm"
        variant={hasDrift ? "default" : "ghost"}
        className={`h-7 text-xs ${hasDrift ? "bg-red-600 hover:bg-red-700 text-white" : ""}`}
        onClick={() => onContract(brand)}
        data-testid={`contract-btn-${brand.campaign_id}`}
      >
        {hasDrift ? <Flag size={14} weight="fill" className="mr-1" /> : <FileText size={14} className="mr-1" />}
        {hasDrift ? "Review" : "Contract"}
      </Button>
      <button
        type="button"
        onClick={() => onRefPolicy(brand)}
        className={`h-7 w-7 inline-flex items-center justify-center rounded transition-colors ${
          hasRefOverride
            ? "bg-emerald-50 text-emerald-700 hover:bg-emerald-100"
            : "text-slate-500 hover:bg-slate-100 hover:text-emerald-700"
        }`}
        title={hasRefOverride ? "Custom Referrer Policy active" : "Configure Referrer Policy"}
        data-testid={`ref-policy-brand-${brand.campaign_id}`}
      >
        <Shield size={14} weight={hasRefOverride ? "fill" : "regular"} />
      </button>
      <button
        type="button"
        onClick={() => onEdit(brand)}
        className="h-7 w-7 inline-flex items-center justify-center rounded text-slate-500 hover:bg-slate-100 hover:text-[#002FA7]"
        title="Edit brand details"
        data-testid={`edit-brand-${brand.campaign_id}`}
      >
        <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7"></path><path d="M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z"></path></svg>
      </button>
      <button
        type="button"
        onClick={() => onAudit(brand)}
        className="h-7 w-7 inline-flex items-center justify-center rounded text-slate-500 hover:bg-slate-100 hover:text-amber-700"
        title="View audit history"
        data-testid={`audit-brand-${brand.campaign_id}`}
      >
        <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><circle cx="12" cy="12" r="10"></circle><polyline points="12,6 12,12 16,14"></polyline></svg>
      </button>
      <button
        type="button"
        onClick={() => onDelete(brand)}
        className="h-7 w-7 inline-flex items-center justify-center rounded text-slate-500 hover:bg-slate-100 hover:text-rose-700"
        title="Soft-delete brand"
        data-testid={`delete-brand-${brand.campaign_id}`}
      >
        <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><polyline points="3,6 5,6 21,6"></polyline><path d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2"></path></svg>
      </button>
    </div>
  );
}
